/**
 * @prettier
 */

import React, { useCallback } from 'react';
import cx from 'classnames';
import _values from 'lodash/values';
import _fromPairs from 'lodash/fromPairs';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { connect } from 'react-redux';
import { SAMPLES_MODAL_DEFAULT_OPTIONS } from '~/cards/components/common/modals/SamplesModal/defaultOptions';
import { getMultiSampleState } from '~/cards/selectors/samples';
import { openModal } from '~/cards/actions/modalActions';
import styles from './styles.module.less';

export const CustomizeButtonBase = ({
  multiSampleState,
  showModal,
  btnSize = 'medium',
  scrollActive = false,
}) => {
  const { limit } = multiSampleState.count;

  const handleOpenModal = useCallback(() => {
    const cards = _values(multiSampleState.selected);
    const selectedColorSet = _fromPairs(cards.map((card) => [card.suiteUUID, card.initialColor]));

    return showModal({
      entryPoint: 'PLP_MULTI',
      cardNameList: cards.map((card) => card.name),
      cardSuiteUUIDList: cards.map((card) => card.suiteUUID),
      cardUUIDList: cards.map((card) => card.uuid),
      isMagnet: false,
      selectedColorSet,
    });
  }, [multiSampleState, showModal]);

  if (!multiSampleState.enabled) {
    return null;
  }

  const numSelected = Object.keys(multiSampleState.selected).length;

  const buttonDisabled = numSelected === 0;

  let buttonText;

  if (buttonDisabled) {
    buttonText = `Select design${limit === 1 ? '' : 's'} (0 of ${limit})`;
  } else {
    buttonText = `Customize design${numSelected === 1 ? '' : 's'} (${numSelected} of ${limit})`;
  }

  return (
    <div
      className={cx(styles.customizationButtonBox, {
        [styles.stickyCustomizationButtonBox]: scrollActive,
      })}
    >
      <ButtonV3 size={btnSize} disabled={buttonDisabled} onClick={handleOpenModal} fullWidth>
        {buttonText}
      </ButtonV3>
    </div>
  );
};

export const mapStateToProps = (state) => ({
  multiSampleState: getMultiSampleState(state),
});

const mapDispatchToProps = (dispatch) => ({
  showModal: (props) => dispatch(openModal('SAMPLES_MODAL', props, SAMPLES_MODAL_DEFAULT_OPTIONS)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomizeButtonBase);
